import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../components/nav';
import { Footer } from '../components/footer';
import { FaHome } from 'react-icons/fa';

// Legal notice required by § 5 DDG: kept in German, as German law expects.
// TODO: replace every [ ... ] placeholder with the real details before going live.
const OPERATOR = {
  name: '[Vor- und Nachname bzw. Firma mit Rechtsform]',
  representative: '[Nur bei GmbH/UG: Vertreten durch die Geschäftsführung – Name]',
  street: 'Aristotelessteig 10',
  city: '10318 Berlin',
  country: 'Deutschland',
  phone: '+49 176 86660296',
  phoneHref: 'tel:+4917686660296',
  email: 'contact@namke.app',
  register: '[Nur falls eingetragen: Registergericht, z. B. Amtsgericht Charlottenburg – HRB …]',
  vatId: '[USt-IdNr. DE… – Abschnitt entfernen, falls keine vorhanden]',
};

function Section({ title, children }) {
  return (
    <section className="bg-white rounded-2xl p-8 mb-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">{title}</h2>
      <div className="space-y-2 text-gray-700 leading-relaxed">{children}</div>
    </section>
  );
}

export default function Impressum() {
  return (
    <>
      <NavBar />
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-4">
          <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-6">
            <Link to="/" className="flex items-center hover:text-green-600 transition-colors">
              <FaHome className="w-4 h-4 mr-1" />
              Startseite
            </Link>
            <span className="text-gray-400">/</span>
            <span className="text-gray-900 font-medium">Impressum</span>
          </nav>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" lang="de">
          <h1 className="text-4xl font-bold text-gray-900 mb-12 text-center">Impressum</h1>

          <Section title="Angaben gemäß § 5 DDG">
            <p>
              {OPERATOR.name}<br />
              {OPERATOR.representative}<br />
              {OPERATOR.street}<br />
              {OPERATOR.city}<br />
              {OPERATOR.country}
            </p>
          </Section>

          <Section title="Kontakt">
            <p>
              Telefon: <a href={OPERATOR.phoneHref} className="text-[rgb(239,76,35)]">{OPERATOR.phone}</a><br />
              E-Mail: <a href={`mailto:${OPERATOR.email}`} className="text-[rgb(239,76,35)]">{OPERATOR.email}</a>
            </p>
          </Section>

          <Section title="Registereintrag">
            <p>{OPERATOR.register}</p>
          </Section>

          <Section title="Umsatzsteuer-ID">
            <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz: {OPERATOR.vatId}</p>
          </Section>

          <Section title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
            <p>
              {OPERATOR.name}<br />
              {OPERATOR.street}, {OPERATOR.city}
            </p>
          </Section>

          <Section title="Verbraucherstreitbeilegung">
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </Section>
        </div>
      </div>
      <Footer />
    </>
  );
}
